import { render, staticRenderFns } from "./main-section.vue?vue&type=template&id=c56637d2&scoped=true&"
import script from "./main-section.vue?vue&type=script&lang=js&"
export * from "./main-section.vue?vue&type=script&lang=js&"
import style0 from "./main-section.vue?vue&type=style&index=0&id=c56637d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56637d2",
  null
  
)

export default component.exports